import {__} from "./__";

export const getCheckoutItemName = type => {
    switch (type) {
        case 'month':
            return __('Automat členstvo - mesiac');

        case 'year':
            return __('Automat členstvo - rok');

        case 'year-manual':
            return __('Manual členstvo - rok');

        case 'month-manual':
            return __('Manual členstvo - mesiac');

        case 'ai':
        case 'ai-20':
        case 'ai-50':
        case 'ai-100':
        case 'ai-200':
        case 'ai-500':
            return __('AI balík');
    }

    return '-';
};
